var exports = {
  "zb": "x61f99309--dfda66--container-desktop",
  "DP": "x61f99309--dfda66--container-mobile",
  "DS": "x61f99309--dfda66--buttons-desktop",
  "vU": "x61f99309--dfda66--buttons-mobile",
};

module.exports = exports;
